import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import HomeFour from "../HomePages/home-four/homeFour";
import Courses from "../Courses/courses";
import Testimonials from "../Pages/testimonials/testimonials";
import Faq from "../Pages/faq/faq";
import CourseDetailsWrapper from "../Courses/course-details/CourseDetailsWrapper";
import BookAppointment from "../Pages/BookAppointment";
import FaqG2G from "../Pages/faq/FaqG2G";
import ContactUsG2G from "../Pages/contact-us/ContactUsG2G";
import Blog from "../blog/Blog";
import Checkout from "../Courses/course-checkout/Checkout";
import AboutUsG2G from "../Pages/about-us/aboutUsG2G";
import LoginPage from "../auth/login/LoginPage";
import RegisterPage from "../auth/register/RegisterPage";
import EligibilityCheckPage from "../Pages/eligibility-check/EligibilityCheckPage";

const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.homefour,
    element: <HomeFour />,
    route: Route,
  },

  {
    path: routes.courseCheckout,
    element: <Checkout />,
    route: Route,
  },

  {
    path: routes.courseDetails,
    element: <CourseDetailsWrapper />, // this will fetch course based on slug
    route: Route,
  },
  {
    path: routes.courses,
    element: <Courses />,
    route: Route,
  },
  {
    path: routes.bookAppointment,
    element: <BookAppointment />,
    route: Route,
  },
  {
    path: routes.faq,
    element: <FaqG2G />,
    route: Route,
  },
  {
    path: routes.blog,
    element: <Blog />,
    route: Route,
  },
  {
    path: routes.about_us,
    element: <AboutUsG2G />,
    route: Route,
  },
  {
    path: routes.contactUs,
    element: <ContactUsG2G />,
    route: Route,
  },
  {
    path: routes.testimonials,
    element: <Testimonials />,
    route: Route,
  },
  {
    path: routes.FAQ,
    element: <Faq />,
    route: Route,
  },

  {
    path: routes.eligibilitycheck,
    element: <EligibilityCheckPage />,
    route: Route,
  },
];

// export const authRoutes = [
//   {
//     path: routes.register,
//     element: <RegisterPage />,
//     route: Route,
//   },
// ];
